function e(e){return new Promise(function(t){var n,r=0;for(n=0;n<e.length;n++)r=(r<<5)-r+e.charCodeAt(n),r|=0;var o=document.getElementById(String(r));o||((o=document.createElement("script")).src=e,o.id=String(r),document.body.append(o)),t(o)})}export default e;
//# sourceMappingURL=index.module.js.map
